/**
 * Tope de Crear Envío: costo de envío del pedido más 20%.
 * Sin costo, o en cero, no hay tope.
 */
export function getShippingQuoteLimit(envio: unknown): number | null {
  if (envio == null || String(envio).trim() === '') return null
  const value = parseFloat(String(envio))
  if (!Number.isFinite(value) || value <= 0) return null
  return Math.round(value * 1.2)
}

export function quoteExceedsShippingLimit(precio: number, limit: number | null): boolean {
  if (limit == null) return false
  return precio > limit
}
